import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';

// ── Composant multi-sélection ─────────────────────────────────────────────────

function StringMultiSelectInput({ item, applyValue, options = [] }) {
    const selected = Array.isArray(item.value) ? item.value : [];

    return (
        <Autocomplete
            multiple
            size="small"
            options={options}
            value={selected}
            onChange={(_, newValue) => applyValue({ ...item, value: newValue })}
            disableCloseOnSelect
            limitTags={2}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip
                        key={option}
                        label={option}
                        size="small"
                        {...getTagProps({ index })}
                        sx={{ fontSize: '0.7rem', height: 18 }}
                    />
                ))
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="standard"
                    placeholder={selected.length === 0 ? 'Sélectionner…' : ''}
                    sx={{ minWidth: 180 }}
                />
            )}
            renderOption={(props, option) => (
                <Box component="li" {...props} sx={{ fontSize: '0.82rem', py: '2px !important' }}>
                    {option}
                </Box>
            )}
            sx={{ minWidth: 180, mt: 0.5 }}
        />
    );
}

// ── Fabrique de l'opérateur (reçoit les valeurs disponibles de la colonne) ────

export function createStringMultiSelectOperator(options = [], listSeparator = ' | ') {
    // Trier et dédupliquer
    const sorted = [...new Set(options)].filter(v => v != null && v !== '').sort();

    return {
        label: 'est parmi',
        value: 'isAnyOf_multi',
        getApplyFilterFn(filterItem) {
            const selected = Array.isArray(filterItem.value) ? filterItem.value : [];
            if (selected.length === 0) return null;
            const set = new Set(selected);
            return (cellValue) => {
                // Gérer les valeurs multiples séparées par le séparateur de liste courant
                if (typeof cellValue === 'string' && cellValue.includes(listSeparator)) {
                    return cellValue.split(listSeparator).some(v => set.has(v.trim()));
                }
                return set.has(cellValue);
            };
        },
        InputComponent: (props) => <StringMultiSelectInput {...props} options={sorted} />,
    };
}

